//region :: Imports ::
import {ReactElement} from 'react';
import MComponent from '../../Toolkit/Components/Component';
import {Calendar, CalendarChangeParams} from 'primereact/calendar';
import {evalulateBool, MBoolean} from '../../Toolkit/Components/Controls/Control';
import {FieldProps} from 'formik';
import {setFieldValue} from '../../Toolkit/Utils';

//endregion

/** */
type Props = {
    id: string;
    initialValue?: Date;
    placeholderText?: string;
    fieldProps?: FieldProps;
    disabled: MBoolean;
    className?: string;
    onChange?: (newValue: Date | undefined) => void;
    showTime?: boolean;
    timeOnly?: boolean;
    showButtonBar?: boolean;
    hourFormat?: "12" | "24";
    minDate?: Date;
    maxDate?: Date;
}

/** */
type State = {
    value?: Date;
}

/** */
class MCalendar extends MComponent<Props, State> {

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();
        this.initializeState();

    }

    /** */
    public bindMethods(): void {
        this.calendar_onChange = this.calendar_onChange.bind(this);
    }

    /** */
    private initializeState(): void {

        this.state = {value: this.props.initialValue};
        setFieldValue(this.props.fieldProps, this.state.value);

    }

    /** */
    private calendar_onChange(params: CalendarChangeParams): void {
        this.setValue(params.value as Date | undefined);
    }

    /** */
    public setValue(newValue: Date | undefined): void {

        this.safeSetState((draft: State) => draft.value = newValue);
        setFieldValue(this.props.fieldProps, newValue);
        this.props.onChange?.(newValue);

    }

    /** */
    public componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {

        if(this.props.fieldProps?.field.value !== prevProps.fieldProps?.field.value) {

            this.safeSetState((draft: State) =>
                draft.value = this.props.fieldProps!.field.value);

        }

    }

    /** */
    public render(): ReactElement {

        return (
            <Calendar id={this.props.id}
                      placeholder={this.props.placeholderText}
                      dateFormat="dd/mm/yy"
                      required={true}
                      readOnlyInput={true}
                      showIcon={true}
                      showButtonBar={this.props.showButtonBar ?? true}
                      disabled={evalulateBool(this.props.disabled)}
                      className={this.props.className}
                      {
                          ...this.props.fieldProps?.field
                      }
                      value={this.state.value}
                      onChange={this.calendar_onChange}
                      showTime={this.props.showTime ?? false}
                      timeOnly={this.props.timeOnly ?? false}
                      hourFormat={this.props.hourFormat ?? '12'}
                      minDate={this.props.minDate}
                      maxDate={this.props.maxDate}
                      selectionMode={'single'}
            />
        );

    }

}

export default MCalendar;
